// extracted by mini-css-extract-plugin
export default {"chevron-left-icon":"styles-module__chevron-left-icon___836793","chevronLeftIcon":"styles-module__chevron-left-icon___836793"};